import { CheckOutlined, CloseOutlined, FilterOutlined } from '@ant-design/icons'
import { Badge } from 'antd'
import classNames from 'classnames'

import cn from './FeedFilterActions.module.scss'

interface FeedFilterActionsProps {
  filtersCount: number
  totalCount: number
  loading: boolean
  canReset: boolean
  withLeftovers: boolean
  organisationSelected: boolean
  onOpenFilters: () => void
  onReset: () => void
  onToggleLeftovers: () => void
}

function FeedFilterActions({
  filtersCount,
  totalCount,
  loading,
  canReset,
  withLeftovers,
  organisationSelected,
  onOpenFilters,
  onReset,
  onToggleLeftovers,
}: FeedFilterActionsProps) {
  return (
    <div
      className={classNames(
        cn.actions,
        organisationSelected && cn.organisationSelected
      )}
    >
      <Badge count={filtersCount} overflowCount={99} className={cn.badge}>
        <button
          type="button"
          className={cn.squareButton}
          aria-label="Фильтры"
          title="Фильтры"
          onClick={onOpenFilters}
        >
          <FilterOutlined />
        </button>
      </Badge>
      <button
        type="button"
        className={cn.squareButton}
        aria-label="Сбросить фильтры"
        title="Сбросить фильтры"
        disabled={!canReset}
        onClick={onReset}
      >
        <CloseOutlined />
      </button>
      <button
        type="button"
        className={classNames(cn.stockButton, withLeftovers && cn.stockActive)}
        aria-pressed={withLeftovers}
        onClick={onToggleLeftovers}
      >
        <CheckOutlined aria-hidden />В наличии
      </button>
      <span className={cn.foundBadge}>
        Найдено: {loading ? '…' : totalCount}
      </span>
    </div>
  )
}

export default FeedFilterActions
